import { Hero } from './Hero';
import { BoxRow } from './BoxRow';
import { CampaignRow, CampaignRowProduct } from './CampaignRow';
import { ImageBoxItem, TextBoxItem, ProductBoxItem } from './BoxItems';
import { Spacer } from './Spacer';
import { ProductRow, ProductRowItem } from './ProductRow';
import { TextPush } from './TextPush';
import { Title } from './Title';
import { ContentRow, ContentRowItem } from './ContentRow';
import { VideoPopup } from '../Content/PreviewAndVideoPopup';
import { CareProduct } from './CareProduct';
import { ImageLinksRow, ImageLinksRowItem } from './ImageLinksRow';
import { ImageGallery, ImageGalleryItem } from './ImageGallery';
import {
  TextSection,
  TextSectionIngressItem,
  TextSectionItem,
} from './TextSection';
import {
  LargeProductCardList,
  LargeProductCardItem,
} from './LargeProductCardList';
import { PLPTextBlock } from './PLPTextBlock';
import { FAQ, FAQItem } from './FAQ';
import { ImagePush, ImagePushImageItem } from './ImagePush';
import {
  ImageTextPush,
  ImageTextPushImageItem,
  ImageTextPushTextItem,
} from './ImageTextPush';
import { Contact } from './Contact';
import { Map } from './Map';
import { SofaConfigurator } from './SofaConfigurator';
import { Employees, EmployeesItem } from './Employees';
import { ShopInformation } from './ShopInformation';
import { GoogleReviews } from '../ui/GoogleReviews';
import { StartPageBoxRow } from './NewStartPageComponents/StartPageBoxRow';
import { StartPageProductRow } from './NewStartPageComponents/StartPageProductRow';
import { StartpageHtlm } from './NewStartPageComponents/StartpageHtlm';
import {
  StartPageCardSlider,
  StartPageCardSliderItem,
} from './NewStartPageComponents/StartPageCardSlider';
import {
  StartPageLinkGrid,
  StartPageLinkGridItem,
} from './NewStartPageComponents/StartPageLinkGrid';
import { StartPageImageLinksRow } from './NewStartPageComponents/StartPageImageLinkRow';
import { StartPageStoresMapView } from './NewStartPageComponents/StartPageStoresMapView';
import { StartPageNewsletter } from './NewStartPageComponents/StartPageNewsletter';
import {
  StartPageMarquee,
  StartPageMarqueeItem,
} from './NewStartPageComponents/StartPageMarquee';
import {
  DualBoxItem,
  StartPageDualBox,
} from './NewStartPageComponents/StartPageDualBox';
import { StartPageSingleBox } from './NewStartPageComponents/StartPageSingleBox';

export const contentEditorComponents = {
  HERO: Hero,
  TEXTBOX: TextBoxItem,
  IMAGEBOX: ImageBoxItem,
  PRODUCTBOX: ProductBoxItem,
  SPACER: Spacer,
  BOXROW: BoxRow,
  CAMPAIGNROW: CampaignRow,
  CAMPAIGNROWPRODUCT: CampaignRowProduct,
  PRODUCTROW: ProductRow,
  PRODUCTROWITEM: ProductRowItem,
  TEXTPUSH: TextPush,
  TITLE: Title,
  CONTENTROW: ContentRow,
  CONTENTROWITEM: ContentRowItem,
  VIDEOPLAYER: VideoPopup,
  CAREPRODUCT: CareProduct,
  IMAGELINKSROW: ImageLinksRow,
  IMAGELINKSROWITEM: ImageLinksRowItem,
  CATEGORYIMAGELINKSROW: ImageLinksRow,
  CATEGORYIMAGELINKSROWITEM: ImageLinksRowItem,
  IMAGEGALLERY: ImageGallery,
  IMAGEGALLERYITEM: ImageGalleryItem,
  TEXTSECTION: TextSection,
  TEXTSECTIONITEM: TextSectionItem,
  TEXTSECTIONINGRESSITEM: TextSectionIngressItem,
  FAQ: FAQ,
  FAQITEM: FAQItem,
  IMAGETEXTPUSH: ImageTextPush,
  IMAGETEXTPUSHIMAGEITEM: ImageTextPushImageItem,
  IMAGETEXTPUSHTEXTITEM: ImageTextPushTextItem,
  IMAGEPUSH: ImagePush,
  IMAGEPUSHIMAGEITEM: ImagePushImageItem,
  CONTACT: Contact,
  MAP: Map,
  SOFACONFIGURATOR: SofaConfigurator,
  EMPLOYEES: Employees,
  EMPLOYEESITEM: EmployeesItem,
  SHOPINFORMATION: ShopInformation,
  // 'GOOGLE REVIEWS': GoogleReviews,
  'STARTPAGE-BOXROW': StartPageBoxRow,
  'STARTPAGE-PRODUCTROW': StartPageProductRow,
  'STARTPAGE-HTML': StartpageHtlm,
  'STARTPAGE-CARDSLIDER': StartPageCardSlider,
  CARDSLIDERITEM: StartPageCardSliderItem,
  'STARTPAGE-LINKGRID': StartPageLinkGrid,
  STARTPAGELINKGRIDITEM: StartPageLinkGridItem,
  'STARTPAGE-IMAGELINKSROW': StartPageImageLinksRow,
  'STARTPAGE-STORESMAPVIEW': StartPageStoresMapView,
  'STARTPAGE-NEWSLETTER': StartPageNewsletter,
  'STARTPAGE-MARQUEE': StartPageMarquee,
  'STARTPAGE-MARQUEEITEM': StartPageMarqueeItem,
  'STARTPAGE-DUALBOX': StartPageDualBox,
  'STARTPAGE-DUALBOXITEM': DualBoxItem,
  'STARTPAGE-SINGLEBOX': StartPageSingleBox,
};

export const categoryPageComponents = {
  PLP_LARGEPRODUCTCARDLIST: LargeProductCardList,
  LARGEPRODUCTCARDITEM: LargeProductCardItem,
  PLP_TEXTBLOCK: PLPTextBlock,
};
